import {
  CardLabel,
  HelperText,
  RowError,
} from "../../../components/MobileForm/styles";
import {
  INTEREST_DIRECTION_HELPER,
  INTEREST_DIRECTION_LABEL,
  INTEREST_DIRECTION_SEGMENTS,
} from "./constants";
import { ToneSegments } from "../../../components/FormPanel";
import { InterestDirectionFieldProps } from "./types";

// The compact twin of `InterestDirectionField`, reading the same copy and rendering the same error.
export const MobileInterestDirectionField = ({
  value,
  groupLabel,
  isSubmitting,
  error,
  onChange,
}: InterestDirectionFieldProps) => (
  <>
    <CardLabel as="span">{INTEREST_DIRECTION_LABEL}</CardLabel>
    <ToneSegments
      groupLabel={groupLabel}
      options={INTEREST_DIRECTION_SEGMENTS}
      selectedValue={value}
      disabled={isSubmitting}
      onChange={(segment) => onChange(segment.value)}
    />
    <HelperText>{INTEREST_DIRECTION_HELPER}</HelperText>
    {error && <RowError role="alert">{error}</RowError>}
  </>
);
